import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-bulk-delete-toolbar',
  templateUrl: './bulk-delete-toolbar.component.html',
  styleUrls: ['./bulk-delete-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkDeleteToolbarComponent {
  @Input() selectionMode = false;
  @Input() selectedCount = 0;
  @Input() selectableCount = 0;
  @Input() isAllSelected = false;
  @Input() deletePermission = 'canDelete';
  @Input() confirmTitle = 'Are you sure you want to delete selected records?';
  @Input() confirmText = 'This cannot be undone';
  @Input() bulkButtonLabel = 'Bulk Delete';
  @Input() deleteSelectedLabel = 'Delete Selected';

  @Output() toggleModeRequested = new EventEmitter<void>();
  @Output() selectAllRequested = new EventEmitter<void>();
  @Output() clearSelectionRequested = new EventEmitter<void>();
  @Output() deleteRequested = new EventEmitter<void>();

  get deleteSelectedText(): string {
    return `${this.deleteSelectedLabel} (${this.selectedCount})`;
  }

  onToggleMode(): void {
    this.toggleModeRequested.emit();
  }

  onSelectAll(): void {
    this.selectAllRequested.emit();
  }

  onClearSelection(): void {
    this.clearSelectionRequested.emit();
  }

  onDeleteRequested(): void {
    this.deleteRequested.emit();
  }
}
